import React from "react";
import { Modal, ModalBody, ModalHeader } from "@skbkontur/react-ui";
import { Fit, RowStack } from "@skbkontur/react-stack-layout";
import { Button, ModalFooter } from "react-ui";

import { ModalText } from "./UnitRemoveConfirmModal.styles";

interface UnitRemoveConfirmModalProps {
    name?: string | null;
    hasChildren?: boolean;
    removeChildrenText?: React.ReactNode;
    onRemove: () => void;
    onClose: () => void;
}

export const UnitRemoveConfirmModal = (props: UnitRemoveConfirmModalProps) => (
    <Modal onClose={props.onClose}>
        <ModalHeader>{`Удалить${props.name ? ` ${props.name}` : ""}?`}</ModalHeader>
        <ModalBody>
            <ModalText>Страница будет удалена без возможности восстановить данные.</ModalText>
            {props.hasChildren && (
                <ModalText isDanger={true}>
                    {props.removeChildrenText ?? "Все вложенные разделы также будут удалены."}
                </ModalText>
            )}
        </ModalBody>
        <ModalFooter>
            <RowStack gap={2}>
                <Fit>
                    <Button
                        onClick={props.onRemove}
                        size="medium"
                        use={"danger"}
                        data-tid={"UnitRemoveConfirmModalSubmitButton"}>
                        Удалить
                    </Button>
                </Fit>
                <Fit>
                    <Button onClick={props.onClose} size="medium" data-tid={"UnitRemoveConfirmModalCancelButton"}>
                        Отменить
                    </Button>
                </Fit>
            </RowStack>
        </ModalFooter>
    </Modal>
);
